export default __webpack_public_path__ + "static/media/gallery_11.43e12fc7.jpg";